import { ScopeOverviewLoadingState, ScopeOverviewState } from '../model/scope-overview.state.model'
import { ScopePagination } from '../model/scope-pagination.model'

export const scopeOverviewInitialLoadingState: ScopeOverviewLoadingState = {
  scope: false,
  scopeValues: false,
  scopeRetainedStats: false,
  thirdPartyCostBalance: false,
  addScopeSection: false,
  getScopeDeliverable: false,
  scopeSections: false,
  availableDeliverableTypes: false,
  addScopeDeliverable: false,
  duplicateDeliverable: false,
  updateDeliverable: false,
  deleteDeliverable: false,
  libraryEntry: false,
  libraryTemplate: false,
  outputTemplate: false,
  deleteScopeSection: false,
  deleteScopeFee: false,
  allFees: false,
  allThirdPartyCosts: false,
  allTasks: false,
  updateSection: false,
  updateScopeDetails: false,
  refreshOutdatedCustomFields: false,
  deliverable: {},
  section: {},
}

export const scopeInitialPaginationState: ScopePagination = {
  first: true,
  last: false,
  number: -1,
  numberOfElements: 0,
  size: 0,
  sort: null,
  totalElements: 0,
  totalPages: 0,
  loading: false,
  content: [],
}

export const scopeOverviewInitialState: ScopeOverviewState = {
  activities: [],
  tradedDeliverables: [],
  currentScope: undefined,
  scopeRetainedHourStats: undefined,
  sowRetainedHourStats: undefined,
  thirdPartyCostBalance: undefined,
  loading: scopeOverviewInitialLoadingState,
  loaded: scopeOverviewInitialLoadingState,
  availableDeliverableTypes: undefined,
  deliverableLibraryEntry: undefined,
  deliverableLibraryTemplate: undefined,
  outputTemplate: undefined,
  docxPreview: undefined,
  previewError: undefined,
  teamError: undefined,
  allComponentFees: [],
  allComponentTPCs: [],
  allSectionTPCs: [],
  scenario: undefined,
  configurationHasUpdates: false,
  currentScopeDeliverablesPagination: scopeInitialPaginationState,
  currentScopeSectionsPagination: scopeInitialPaginationState,
  currentScopeSectionDeliverablesPagination: {},
  displayedDeliverablesCount: 0,
}
